var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"third"},[_c('div',{staticStyle:{"margin-bottom":"10px"}}),_vm._m(0),_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('JJXM')],1),_c('YXIMG'),(_vm.cityDetail.cityName == '濮阳市')?_c('PYSYXZCSR'):_vm._e(),(
      _vm.cityDetail.cityName != '濮阳市华龙区' &&
      _vm.cityDetail.cityName != '濮阳市清丰县' &&
      !_vm.cityDetail.notHaveJRFW
    )?_c('div',{staticClass:"jrfw",style:({ cursor: _vm.cityDetail.goJRFWInfo ? 'pointer' : 'auto' }),on:{"click":_vm.goJRFWInfo}},[_vm._m(1)]):_vm._e(),(
      _vm.cityDetail.cityName == '濮阳市华龙区' ||
      _vm.cityDetail.cityName == '濮阳市清丰县'
    )?_c('YQLJ'):_vm._e(),_c('div')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('img',{staticStyle:{"width":"100%","height":"155px"},attrs:{"src":require("@/assets/img/caodi3.png"),"alt":""}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v("金融服务")]),_c('span',[_vm._v("一站式金融服务平台")])])
}]

export { render, staticRenderFns }